export default "__VITE_PUBLIC_ASSET__906cb8f5__"